// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j9dN","colBig":"styles_colBig__30vkr","colSmall":"styles_colSmall__OEOYP","shopifyNameWrapper":"styles_shopifyNameWrapper__wC0Vk"};